<template>
    <v-system-bar
    height="50"
    color="primary"
    dark
    app>
        <h3>Welcome to PRISM Data Portal</h3>
        <v-spacer></v-spacer>
        <v-btn
        small
        rounded
        outlined
        dark
        elevation="0"
        v-b-modal.modal-prevent-closing>
            Submit Feedback
        </v-btn>
        <b-modal
        size="lg"
        id="modal-prevent-closing"
        ref="modal"
        title="Submit Your Feedback"
        @show="resetModal"
        @hidden="resetModal"
        ok-title="Submit"
        @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group>
            <label style="font-weight: bold;">Please submit this feedback form once after reviewing all features of the Portal</label>
            </b-form-group>
            <br/>
            <b-form-group label="1. Is the overall navigation and organization of content throughout the Portal intuitive? If not, what could use improvement?">
            <b-form-radio-group id="nav_org_id" v-model="nav_org_selected" required>
                <b-form-radio value="Yes">Yes</b-form-radio>
                <b-form-radio value="No">No</b-form-radio>
                <b-form-invalid-feedback :state="navOrgState">Please select one</b-form-invalid-feedback>
                <b-form-valid-feedback :state="navOrgState">Thank you</b-form-valid-feedback>
            </b-form-radio-group>
            <br/>
            <v-text-field light outlined v-model="nav_org_message" placeholder="Explain (Optional)"></v-text-field>
            </b-form-group>
            <br/>
            <b-form-group label="2. Were the labels on data and the text throughout the Portal clear and informative?">
            <b-form-radio-group  id="labels_informative_id" v-model="labels_informative_selected" required>
                <b-form-radio value="Yes">Yes</b-form-radio>
                <b-form-radio value="No">No</b-form-radio>
                <b-form-invalid-feedback :state="labelsInformativeState">Please select one</b-form-invalid-feedback>
                <b-form-valid-feedback :state="labelsInformativeState">Thank you</b-form-valid-feedback>
            </b-form-radio-group>

            <br/>
            <v-text-field light outlined v-model="labels_informative_message" placeholder="Explain (Optional)"></v-text-field>
            </b-form-group>
            <br/>
            <b-form-group label="3. At this stage, would you prefer to view your data in the Portal or in the existing PRISM reports?">
            <b-form-radio-group id="preferences_id" v-model="preferences_selected" :options="preferences_options">
                <b-form-invalid-feedback :state="preferencesState">Please select one</b-form-invalid-feedback>
                <b-form-valid-feedback :state="preferencesState">Thank you</b-form-valid-feedback>
            </b-form-radio-group>
            <br/>
            <v-text-field light outlined v-model="preferences_message" placeholder="Please elaborate on the reasons for your preference(Optional)"></v-text-field>
            </b-form-group>
            <br/>
            <b-form-group label="4. If you have questions, comments or additional feedback, please include them here.">
            <v-textarea light outlined v-model="questions_message" placeholder="(Optional)"></v-textarea>
            </b-form-group>
        </form>
        <label>
            If you are willing to meet with our team to discuss your feedback and how you use the portal, we would greatly appreciate your input. Please schedule a convenient time using this
            <a href="https://calendar.app.google/g8epk2puuyEvc6BR6" target="google_cal">link</a>
        </label>
    </b-modal>
</v-system-bar>
</template>
<script>
import * as api from "../js/utils/api";
import {_} from 'vue-underscore';
export default {
  name: 'FeedbackSystemBar',

  data: () => ({
    nav_org_message: null,
    labels_informative_message: null,
    preferences_message: null,
    questions_message: null,
    nav_org_selected: null,
    labels_informative_selected: null,
    preferences_selected: null,

    preferences_options: [
      { text: 'Strongly Prefer Portal', value: 'strongly_prefer_portal' },
      { text: 'Prefer Portal', value: 'prefer_portal' },
      { text: 'No Preference', value: 'no_preference' },
      { text: 'Prefer Reports', value: 'prefer_reports' },
      { text: 'Strongly Prefer Reports', value: 'strongly_prefer_reports' }
    ]
  }),
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    resetModal() {
      this.nav_org_message = '';
      this.labels_informative_message = '';
      this.preferences_message = '';
      this.questions_message = '';

      this.nav_org_selected = '';
      this.labels_informative_selected = '';
      this.preferences_selected = '';
    },
    handleOk(bvModalEvent) {
// Prevent modal from closing
      bvModalEvent.preventDefault()
// Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      const self = this;
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      const found = _.findWhere(self.preferences_options,{value:self.preferences_selected});
      const payload = {
        nav_org_message: this.nav_org_message,
        labels_informative_message: this.labels_informative_message,
        preferences_message: this.preferences_message,
        questions_message: this.questions_message,
        nav_org_selected: this.nav_org_selected,
        labels_informative_selected: this.labels_informative_selected,
        preferences_selected: found.text
      };
      const url = `${self.$API_URL}prism-portal/feedback`;
      let userKey = self.$USER_KEY;
      if(!userKey){
        const email = process.env.VUE_APP_ANONYMOUS_EMAIL;
        const pwd = process.env.VUE_APP_ANONYMOUS_PWD;
        const api_url = process.env.VUE_APP_API_URL;
        userKey = await api.login(api_url, email.toLowerCase(), pwd);
      }
      await api.axiosPost(url,userKey,payload);
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    }
  },
  mounted() {
    const self = this;
    self.$USER_KEY = api.get_USER_KEY();
  },
  computed: {
    navOrgState() {
      return Boolean(this.nav_org_selected)
    },
    preferencesState() {
      return Boolean(this.preferences_selected)
    },
    labelsInformativeState() {
      return Boolean(this.labels_informative_selected)
    }
  }
}
</script>
<style>



</style>
<style scoped>
h3{
  color:#ffffff !important;
  font-weight: 500 !important;
  margin-top: 0px !important;
  margin-bottom:0px !important;
}

h3>i{
  font-weight: 900 !important;
  background: linear-gradient(to right,#FFA427, #FFCD00);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}

</style>
